import { useHttpClient } from '@/common/api/httpClient';
import type { DashboardComponentTypeConfigResponse } from '../models/DashboardComponentTypeConfigResponse';

//exporterar funktionen för att kunna användas i andra filer
export function useListDashboardComponentTypeConfigApi() {
  return {
    execute,
  };

  async function execute() {
    //variabler för att hämta in header och isntällningar för anrop
    const httpClient = useHttpClient();
    const headers = httpClient.defaultHeaders();

    //anrop för att hämta in dashboardcomponenttypeconfigs med get, skickar med headers
    const request = new Request(httpClient.siteUrl('dashboardComponentTypeConfig'), {
      method: 'GET',
      headers,
    });

    //mottar svaret och returnerar
    const response = await httpClient.execute(request);
    if (response.ok) {
      //sparar ned svaret enligt strukturen för responses
      const dashboardComponentTypeConfigs =
        (await response.json()) as DashboardComponentTypeConfigResponse[];
      //filtrerar för att bara spara ner de som är enabled och returnerar dessa
      return dashboardComponentTypeConfigs.filter((dashboardComponentTypeConfig) => dashboardComponentTypeConfig.enabled);
    }

    return [];
  }
}
